import { IntroWrapper } from '../__intro-elements';
import { IntroKeys } from '../intro-keys';

const StoryboardSettingsIntro = () => (
  <IntroWrapper>
    <p>
      Welcome to <b>Storyboard Settings</b>! Here you can configure various aspects of your story including playback,
      transitions, titles, and more.
    </p>
  </IntroWrapper>
);

const TitleCredits = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Title & Credits:</b> Add opening titles and closing credits to your video. You can customize the text content
      and duration for each.
    </p>
    <p>
      Click the <b>Edit Text</b> icons next to the title and credits fields to open the text editor for more advanced
      formatting options.
    </p>
  </IntroWrapper>
);

const TrackSettings = () => (
  <IntroWrapper>
    <p>
      <b>Track Fade-In/Out:</b> Configure how quickly the audio track fades in at the beginning and fades out at the end
      of your video.
    </p>
  </IntroWrapper>
);

const AspectRatio = () => (
  <IntroWrapper>
    <p>
      <b>Aspect Ratio:</b> Choose the video format:
    </p>
    <ul>
      <li>
        <b>16:9:</b> Widescreen format
      </li>
      <li>
        <b>9:16:</b> Vertical format (mobile)
      </li>
    </ul>
  </IntroWrapper>
);

const PlaybackSettings = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Transition Time:</b> Set the duration of transitions between clips in milliseconds. Longer transitions create
      smoother effects between scenes.
    </p>
    <p>
      <b>Playback Rate:</b> Control how fast your video plays. A rate of 1.0 is normal speed, while higher values make
      it faster and lower values make it slower.
    </p>
  </IntroWrapper>
);

const ClipAlignment = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Clip Start Time Alignment:</b> Choose how clips align with beat markers. Options include aligning to the
      transition start or center.
    </p>
    <p>
      <b>Clip Transition Alignment:</b> Control where transitions occur relative to beat markers - leading, centered, or
      trailing.
    </p>
    <p>
      <b>Tip:</b> We recommend leaving these settings at their defaults for the best results with music synchronization.
    </p>
  </IntroWrapper>
);

const ClipOrder = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Clip Order:</b> Determine how clips are arranged in your final video:
    </p>
    <ul>
      <li>
        <b>Chronological:</b> Clips appear in the order they were recorded
      </li>
      <li>
        <b>Random:</b> Clips are shuffled randomly
      </li>
      <li>
        <b>Random (Maintain First & Last):</b> Random order but keeps the first and last clips in their original
        positions
      </li>
    </ul>
    <p>
      <b>Tip:</b> This setting can be left unchanged if you want to manually arrange clips in your preferred order on
      the Storyboard Track.
    </p>
  </IntroWrapper>
);

export const TUTS_SB_SETTINGS = [
  { element: `[data-intro="${IntroKeys.sbSettings}"]`, intro: <StoryboardSettingsIntro /> },
  { element: `[data-intro="${IntroKeys.sbSettings}"]`, intro: <TitleCredits /> },
  { element: `[data-intro="${IntroKeys.sbSettings}"]`, intro: <TrackSettings /> },
  { element: `[data-intro="${IntroKeys.sbSettings}"]`, intro: <AspectRatio /> },
  { element: `[data-intro="${IntroKeys.sbSettings}"]`, intro: <PlaybackSettings /> },
  { element: `[data-intro="${IntroKeys.sbSettings}"]`, intro: <ClipAlignment /> },
  { element: `[data-intro="${IntroKeys.sbSettings}"]`, intro: <ClipOrder /> },
];
